
//  Gsap Plugin import here 

export { default as Gsap } from "../../public/assets/plugins/gsap.js";
export { default as SplitText } from "../../public/assets/plugins/gsap-split-text.js"; 
export { default as ScrollTrigger } from "../../public/assets/plugins/gsap-scroll-trigger.js";
export { default as ScrollSmoother } from "../../public/assets/plugins/gsap-scroll-smoother.js";
export { default as ScrollToPlugin } from "../../public/assets/plugins/gsap-scroll-to-plugin.js";


// export { default as pagePiling } from "../../public/assets/gsap-plugins/pagepiling.js";
// export { default as jQuery } from "../../public/assets/js/vendor/jquery.js"; 
// export { default as Matter } from "../../public/assets/js/matter.js"; 
// export { default as Hammer } from "../../public/assets/js/hammer.js"; 
// export { default as Throwable } from "../../public/assets/js/throwable.js"; 


// Chroma
export { default as chroma } from "../../public/assets/plugins/charming.js";



